import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { FormBaseComponent } from '../../models/form-base-component';
import { FormFieldService } from '../../services/form-field.service';
import { FormColorField } from './form-color.model';

@Component({
  selector: 'gio-form-color',
  templateUrl: './form-color.component.html',
  styleUrls: ['./form-color.component.scss'],
  host: {
    '[class]': 'classNames'
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormColorComponent<N = any> extends FormBaseComponent<FormColorField<N>>{

  @HostBinding('style')
  get myStyle() { return this.getHostStyles(); }

  constructor(
    cd: ChangeDetectorRef,
    public _service: FormFieldService,
    sanitizer: DomSanitizer
  ) { super(cd, _service, sanitizer); }

  onComponentInit() { }
  onComponentDestroy() { }

  changed($event) {
    const { color } = $event;
    if (color) {
      const a: any = {};
      a[this.field.name] = color.hex;
      this.group.patchValue(a);
    }
  }

}
